import { Routes } from '@angular/router';
import { ReferralsGuard } from '../../../app/referrals-guard.guard';
import { withTranslations } from '../i18n/resolvers/translations.resolvers';

export const wikiRoutes: Routes = [
    {
        path: 'ayuda',
        loadChildren: () =>
            import('../../../app/wiki/help/help-center/help-center.module').then(
                (m) => m.HelpCenterModule,
            ),
        canActivate: [ReferralsGuard],
        ...withTranslations('help'),
    },
    {
        path: 'wiki',
        loadChildren: () => import('../../../app/wiki/wiki.module').then((m) => m.WikiModule),
        canActivate: [ReferralsGuard],
    },
];
